import { RecordColorEnum } from '../enums/record-color.enum';

/**
 * Returns a random color value which is used to style the record pill in the UI
 */
export function getRandomColor(): string {
	const colors = Object.values(RecordColorEnum);
	const randomIndex = Math.floor(Math.random() * colors.length);

	return colors[randomIndex];
}
